import React from "react";
import { GET } from "lib/api";
import InputLabelDatePicker from "Components/Fragment/InputLabelDatePicker";
import PriorityDropdown from "lib/components/PriorityDropdown";
import LuvitComponent from "LuvitComponent";
import Form from "lib/components/Form";
import HoursAndMinutesTime from "Components/Fragment/HoursAndMinutesTime";
import { Label } from "lib/components/Form";
import { openExternalURL } from "lib/utils";
import PersonalGoalsDropdown from "lib/components/PersonalGoalsDropdown";
import { IconButton } from "lib/components/Button";
import { Button } from "Components/Base/Inputs/Button";
import { Grid } from "Components/Base/Layout/Grid";
import { Box } from "Components/Base/Layout/Box";
import Dropzone from "react-dropzone";
import SettingStore from "stores/settings";
import ValidationSummary from "lib/components/ValidationSummary";
import ActivitySignedStatus from "./activitySignedStatus";
import { Input } from "Components/Base/Inputs/Input";

const mobileViewport = window.matchMedia("(max-width: 400px)").matches || false;
export default class AddExternal extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "TalentManagement");

    this.state = {
      errorMsgs: [],
      startDate: "",
      endDate: "",
      expireDate: "",
    };

    this.clearForm = this.clearForm.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.setHours = this.setHours.bind(this);
    this.setMinutes = this.setMinutes.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  async componentDidMount() {
    const { activity } = this.props;
    const allowedExtensions = await GET("/v1/allowedextensions");
    const hours = parseInt(activity.hours) || "";
    const minutes = parseInt(activity.minutes) || "";
    const personalGoalId =
      activity && (activity.personalGoalId || activity.goalId);

    this.setState({
      title: activity.title,
      ready: true,
      editDoc: {},
      allowedExtensions,
      hours,
      minutes,
      personalGoalId,
      expireDate: activity.dueDate || activity.deadlineDate || "",
      startDate: activity.startDate || "",
      endDate: activity.endDate || "",
    });
  }

  componentWillReceiveProps(props) {
    let errors = {};
    if (props.error) {
      errors.file = { msg: this.l(props.error) };
    }

    this.setState({ errors });
  }

  async SaveActivity() {
    const { title, files, personalGoalId } = this.state;

    const expireDate =
      this.state.expireDate ||
      this.props.activity.dueDate ||
      this.props.activity.deadlineDate ||
      "";

    let errorMsgs = [];

    if (!title) errorMsgs.push({ msg: this.l("errEnterTitle") });

    if (!this.props.fromEducationHistory && !expireDate) {
      errorMsgs.push({ msg: this.l("enterExpiredate") });
    }

    if (files) {
      if (!this.extOk(files[0].name)) {
        errorMsgs.push({ msg: this.l("extnotallowed") });
      }
    }

    if (errorMsgs.length === 0) {
      let data;
      if (this.props.fromEducationHistory) {
        data = {
          personalId: this.props.personalId,
          attachmentId: this.props.activity.attachmentId,
          title: title,
          comments: this.refs.TxtComment.value || "-",
          isCompleted: true,
          createdBy: this.props.personalId,
          description: this.refs.TxtDescription.value,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          isOtherTraining: false,
          removeAttachment: this.state.removeAttachment,
          hours: this.state.hours,
          minutes: this.state.minutes,
        };
      } else {
        data = {
          personalId: this.props.personalId,
          attachmentId: this.props.activity.attachmentId,
          compTalkId: null,
          courseObjectId: null,
          title: title,
          comments: this.refs.TxtComment.value || "-",
          isCompleted: this.refs.ChkCompleted.checked,
          createdBy: this.props.personalId,
          period: "-",
          priority: this.refs.SelPrio.state.currentValue,
          description: this.refs.TxtDescription.value,
          showComment: false,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          isOtherTraining: false,
          courseId: null,
          deadlineDate: expireDate,
          personalGoalId,
          responsible: this.refs.TxtResponsible.value,
          link: this.refs.TxtLink.value,
          linkLabel: this.refs.TxtLinkLabel.value,
          removeAttachment: this.state.removeAttachment,
          hours: this.state.hours,
          minutes: this.state.minutes,
          isExternalCourse: true,
        };
      }
      this.props.save(data, this.state.files);
    }

    this.setState({ errorMsgs });
  }

  extOk(fileName) {
    let ext = fileName.split(".").pop().toLowerCase();
    return this.state.allowedExtensions.includes(ext);
  }

  onDrop(files) {
    let { errors } = this.state;

    if (errors && errors.file) {
      errors.file = null;
    }

    this.setState({ files, removeAttachment: false, errors });

    if (this.state.editDoc.attachmentId) {
      this.state.editDoc.fileName = files[0].name;
      this.setState({ editDoc: this.state.editDoc });
    }
  }

  renderSelectedFiles() {
    let selectedFiles = <div />;

    if (this.state.files) {
      selectedFiles = this.state.files.map((f) => {
        return (
          <div key={f.name} className="dropzone-selectedfiles-file">
            {f.name}
          </div>
        );
      });
    } else if (
      this.props.activity.attachmentId &&
      !this.state.removeAttachment
    ) {
      selectedFiles = (
        <div
          key={this.props.activity.fileName}
          className="dropzone-selectedfiles-file"
        >
          {this.props.activity.fileName}
        </div>
      );
    }
    return selectedFiles;
  }

  clearForm() {
    this.refs.TxtTitle.value = "";
    this.refs.TxtDescription.value = "";
    this.refs.TxtComment.value = "";
    this.refs.TxtResponsible.value = "";
    this.refs.SelPrio.value = "-";
    this.refs.TxtLink.value = "";

    this.setState({
      expireDate: "",
      startDate: "",
      endDate: "",
    });
  }

  removeFile() {
    if (confirm(this.l("confirmdeletefile"))) {
      this.setState({ removeAttachment: true, files: null });
    }
  }

  setHours(hours) {
    this.setState({ hours: parseInt(hours) });
  }

  setMinutes(minutes) {
    this.setState({ minutes: parseInt(minutes) });
  }

  doRender() {
    if (!this.state || !this.state.ready) return <div />;

    let act = this.props.activity;
    let formContentStyle = mobileViewport
      ? {}
      : { maxHeight: "650px", overflow: "auto" };
    let responsible = this.props.personalName;
    let { editDoc, files } = this.state;

    if (act && act.id) responsible = "";

    const activeExpireDate =
      this.state.expireDate || act.dueDate || act.deadlineDate || "";
    const activeStartDate = this.state.startDate || act.startDate || "";
    const activeEndDate = this.state.endDate || act.endDate || "";

    return (
      <Form onSubmit={() => this.SaveActivity()}>
        <div
          className={
            (!mobileViewport && "scrollbar") + " add-external-inner-container"
          }
          style={formContentStyle}
        >
          {this.state.errorMsgs.length > 0 && (
            <ValidationSummary errors={this.state.errorMsgs} />
          )}
          <div className="input-box margin-b-10">
            <Label
              htmlFor="addactivity-title"
              className="required"
              label={this.l("title") + ":"}
            />
            <Input
              id="addactivity-title"
              placeholder=" "
              defaultValue={act.title}
              onChange={(e) => this.setState({ title: e.target.value })}
              required
            />
          </div>
          <div className="margin-b-10">
            <label htmlFor="TxtDescription">{this.l("description")}:</label>
            <textarea
              id="TxtDescription"
              ref="TxtDescription"
              className="small"
              defaultValue={act.description}
            />
          </div>

          {!this.props.fromEducationHistory && (
            <div className="margin-b-10">
              <label htmlFor="SelPrio">{this.l("priority")}:</label>
              <PriorityDropdown
                defaultValue={act.priority}
                id="SelPrio"
                ref="SelPrio"
              />
            </div>
          )}

          <Box display="flex" sx={{ gap: "16px", flexWrap: "wrap" }}>
            {!this.props.fromEducationHistory && (
              <InputLabelDatePicker
                id="CalExpireDate"
                required
                label={this.l("expiredate")}
                name={this.l("expiredate")}
                value={activeExpireDate}
                onChange={(event) => {
                  this.setState({ expireDate: event.target.value });
                }}
                placeholder={
                  this.state.errors && this.state.errors.CalExpireDate
                    ? this.state.errors.CalExpireDate.msg
                    : null
                }
                oldStyleLabel={true}
              />
            )}

            <InputLabelDatePicker
              id="CalStartDate"
              label={this.l("startdate")}
              name={this.l("startdate")}
              value={activeStartDate}
              onChange={(event) => {
                this.setState({ startDate: event.target.value });
              }}
              placeholder={
                this.state.errors && this.state.errors.CalStartDate
                  ? this.state.errors.CalStartDate.msg
                  : null
              }
              oldStyleLabel={true}
            />

            <InputLabelDatePicker
              id="CalEndDate"
              label={this.l("enddate")}
              name={this.l("enddate")}
              value={activeEndDate}
              onChange={(event) => {
                this.setState({ endDate: event.target.value });
              }}
              placeholder={
                this.state.errors && this.state.errors.CalEndDate
                  ? this.state.errors.CalEndDate.msg
                  : null
              }
              oldStyleLabel={true}
            />
          </Box>

          <div className="margin-b-10">
            <HoursAndMinutesTime
              itemHours={this.state.hours}
              setItemHours={this.setHours}
              itemMinutes={this.state.minutes}
              setItemMinutes={this.setMinutes}
              hourLabel={this.l("hours")}
              minutesLabel={this.l("minutes")}
            />
          </div>

          {!this.props.fromEducationHistory && (
            <div className="margin-b-10">
              <label htmlFor="SelPersonalGoal">
                {this.l("connecttogoal") + ":"}
              </label>
              <PersonalGoalsDropdown
                id="SelPersonalGoal"
                ref="SelPersonalGoal"
                personalId={this.props.personalId}
                defaultValue={act.personalGoalId || act.goalId}
                updateParentState={(newValue) =>
                  this.setState({ personalGoalId: newValue })
                }
              />
            </div>
          )}
          {!this.props.fromEducationHistory && (
            <div className="margin-b-10">
              <label htmlFor="TxtResponsible">{this.l("responsible1")}:</label>
              <input
                className="input"
                type="text"
                id="TxtResponsible"
                ref="TxtResponsible"
                defaultValue={act.responsible || responsible}
              />
            </div>
          )}

          {!this.props.fromEducationHistory && (
            <div className="flex flex-wrap margin-b-10">
              <div>
                <label htmlFor="addactivity-link">
                  {this.l("html-editor-link") + ":"}
                </label>
                <input
                  id="addactivity-link"
                  type="text"
                  className="input"
                  ref="TxtLink"
                  defaultValue={act.link}
                />
                <IconButton
                  onClick={() => {
                    this.refs.TxtLink.value !== ""
                      ? openExternalURL(this.refs.TxtLink.value)
                      : null;
                  }}
                  icon="icon-link"
                  label={this.l("openlink")}
                />
              </div>
              &nbsp; &nbsp;
              <div className={this.props.fromEducationHistory ? "hidden" : ""}>
                <label htmlFor="addactivity-link-label">
                  {this.l("linklabel") + ":"}
                </label>
                <input
                  id="addactivity-link-label"
                  type="text"
                  className="input"
                  ref="TxtLinkLabel"
                  defaultValue={act.linkLabel}
                />
              </div>
            </div>
          )}
          {this.props.allowAttachment && (
            <div>
              <label htmlFor="dropzoneInput">
                {this.l("document") +
                  " (" +
                  this.l("maxfilesize").toLowerCase() +
                  ": " +
                  SettingStore.getSettingValue("activityAttachmentMaxSize") +
                  " MB)"}
                :
              </label>

              <div className="flex">
                <span>{this.l("selectedfile")}: &nbsp;</span>
                <div
                  className={
                    files || this.props.activity.attachmentId
                      ? "dropzone-selectedfiles"
                      : "hidden"
                  }
                >
                  <div ref="selectedfiles">{this.renderSelectedFiles()}</div>
                </div>
                {(this.state.files || this.props.activity.attachmentId) &&
                  !this.state.removeAttachment && (
                    <span
                      className="pointer"
                      style={{ position: "relative", top: "-10px" }}
                      role="button"
                      title="Ta bort"
                      onClick={this.removeFile}
                    >
                      <i
                        className="iconbutton-icon icon-trash"
                        aria-hidden="true"
                        tabIndex="0"
                      />
                    </span>
                  )}
              </div>
              {this.state.errors && this.state.errors.file && (
                <div className="color-error">
                  {this.l(this.state.errors.file.msg).replace(
                    "%maxfilesize%",
                    SettingStore.getSettingValue("activityAttachmentMaxSize") +
                      " MB",
                  )}
                </div>
              )}
              <br />
              <Dropzone
                inputProps={{ id: "dropzoneInput" }}
                id="DropZone"
                className="dropzone"
                onDrop={this.onDrop}
                multiple={false}
              >
                <div>
                  {files || editDoc.attachmentId
                    ? this.l("dropzoneinfo2")
                    : this.l("dropzoneinfo")}
                </div>
              </Dropzone>
            </div>
          )}
          <div>
            <label htmlFor="TxtComment">{this.l("comment")}:</label>
            <textarea
              className="small"
              id="TxtComment"
              ref="TxtComment"
              defaultValue={act.comments}
            />
          </div>
          <br />
          <div
            className={
              this.props.fromEducationHistory ||
              (this.props.allowUsersToCompleteCourses == "0" &&
                !this.props.isManager)
                ? "hidden"
                : ""
            }
          >
            <label htmlFor="ChkCompleted">{this.l("coursecompleted")}:</label>
            <input
              type="checkbox"
              id="ChkCompleted"
              ref="ChkCompleted"
              defaultChecked={act.isCompleted}
            />
            <br />
            <br />
          </div>
        </div>
        <Grid container spacing={1} justifyContent="flex-end">
          {false && (
            <Grid item>
              <ActivitySignedStatus />
            </Grid>
          )}
          <Grid item>
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.props.onCancel}
              label={this.l("cancel")}
            />
          </Grid>
          <Grid item>
            <Button type="submit" label={this.l("save")} />
          </Grid>
        </Grid>
      </Form>
    );
  }
}
